@if (environment.production) {
  <footer class="footer fixed-bottom">
    <div class="text-center bg-white f-14 p-2">
      <span class="footer-text-primary">
        &copy; {{ year }} EYGM Limited | All Rights Reserved | Content within
        this application is confidential and meant for EY staff and EY clients
        only. Please review the
        <a
          class="blue_text"
          href="/privacy-notice"
          target="_blank"
          rel="noopener"
          >Privacy Notice</a
        >,
        <a
          class="blue_text"
          href="https://login.ey.com/myey/terms-of-use"
          target="_blank"
          rel="noopener"
          >Terms of Use</a
        >
        and
        <a
          class="blue_text"
          href="/cookie-policies"
          target="_blank"
          rel="noopener"
          >Cookie Policies</a
        >
        for additional information.
        <p class="footer-text-secondary">
          Please do not enter any unnecessary personal information or any
          sensitive personal data (including government identifiers such as tax
          file numbers or social security numbers), client confidential
          information, audit secrets, state secrets, commercial secrets, or
          anything that would violate professional secrecy or confidentiality
          rules or that would be considered abusive/irrelevant
        </p>
      </span>
    </div>
  </footer>
} @else {
  <footer class="footer fixed-bottom">
    <div class="text-center bg-white f-14 p-2">
      <span class="footer-text-primary">
        &copy; {{ year }} SAWT Limited | All Rights Reserved | Content within
        this application is confidential and meant for SAWT staff and SAWT
        clients only.
        <p class="footer-text-secondary">
          Please do not enter any unnecessary personal information or any
          sensitive personal data (including government identifiers such as tax
          file numbers or social security numbers), client confidential
          information, audit secrets, state secrets, commercial secrets, or
          anything that would violate professional secrecy or confidentiality
          rules or that would be considered abusive/irrelevant
        </p>
      </span>
    </div>
  </footer>
}
